export default __webpack_public_path__ + "static/media/icon_rights_response_site.740399b7.svg";